<template>
    <el-form ref="form" :model="form" label-width="10%">
        <el-form-item label="标题">
            <!--:disabled=" obj.initiator == 'RETAIL'" -->
            <el-input placeholder="请填写标题" v-model="form.title"
                      clearable></el-input>
        </el-form-item>
        <!--:disabled=" obj.initiator == 'RETAIL'"-->

        <el-form-item label="发生日期">
            <div class="block">
                <el-date-picker
                        v-model="form.date"
                        type="date"
                        placeholder="选择日期">
                </el-date-picker>
            </div>
        </el-form-item>
        <!--:disabled=" obj.initiator == 'RETAIL'"-->

        <el-form-item label="详情说明">
            <el-input
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 10}"
                    placeholder="请输入备注信息"
                    v-model="form.comments">
            </el-input>

        </el-form-item>
        <!--:disabled="obj.initiator == 'RETAIL'"-->
        <el-form-item label="联系方式">
            <el-input placeholder="请输入联系方式"  v-model="form.phone"
                      clearable></el-input>
        </el-form-item>
        <el-form-item label="现场照片">

            <!--:disabled=" obj.initiator == 'RETAIL'"-->

            <el-upload
                    action="https://api.retailstore365.com:15041/uploadphoto"
                    :http-request="uploadFun"
                    list-type="picture-card"
                    :show-file-list="true" multiple
                    :on-preview="handlePictureCardPreview"
                    :on-success="handleImgSuccess"
                    :before-upload="beforeImgUpload"
                    :on-remove="handleRemove"
                    :file-list="form.fileList">

                <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>

        </el-form-item>
    </el-form>
</template>

<script>
    import http from '../../../APIService/http'

    export default {
        props: {

        },
        components: {},
        data() {
            return {
                form: {
                    title: "",
                    date: "",
                    comments: "",
                    phone: "",
                    photos: [],
                    fileList: [],
                    account_id: "",
                    key: "",
                    service_worker: ""
                },
                obj: {
//                    initiator: "RETAIL"
                    initiator: "SERVICE",
                    created_by: "",
                    account_name: "",
                    store_name: "",
                    alias: "",
                    ticket_id: '',
                    ticket_no: "",
                    phone: "",
                    photo: [],
                    status: "NEW",
                    stepDatas: [{title: "已接单"},
                        {title: "已派单"},
                        {title: "进行中"},
                        {title: "已完工"},
                        {title: "已评价"}],
                    reference_obj : ''

                },
            }
        },
        computed: {},
        created() {

        },
        methods: {
            getObj(data){
              this.obj = data
            },
            setInfo(data){


                this.form.title = data.title
                this.form.date = data.date
                this.form.comments = data.comments
                this.form.phone = data.phone
                this.form.fileList = data.fileList
                this.form.photos = data.photos
                this.form.account_id = data.account_id
                this.form.key = data.key
                this.form.service_worker = data.service_worker


            },

            getInfo(){

                var obj = {}

                obj.title = this.form.title
                obj.comments = this.form.comments
                obj.date = this.form.date
                obj.phone = this.form.phone
                obj.key = this.form.key
                obj.account_id = this.form.account_id
                obj.service_worker = this.form.service_worker
                obj.photos = []

                for (var i = 0; i <  this.form.photos.length; i++){
                    var dic = this.form.photos[i]
                    obj.photos.push(dic.file_id)
                }

                return obj
            },

            async uploadFun(param) {


                var user = this.$store.getters.getUser


                var data = new FormData(); //创建form对象
                data.append('file', param.file);
                data.append('reference_obj', user.reference_obj);
                data.append('reference_id', user.reference_id);
                data.append('credential', user.client_secret);
                data.append('username', user.username);
                data.append('tenant_id', user.tenant_id);
                data.append('user_id', user.user_id);
                data.append('category', 'USER');
                data.append('size', '300');


                var config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                };  //添加请求头

                let res = await http.post(param.action, data)
                if (res.success) {
                    var s3filename = res.data.s3filename
                    var obj = this.form.photos[this.form.photos.length - 1]
                    obj.file_id = s3filename
                }
            },
            handlePictureCardPreview(file) {
                this.$emit('showImageAction', {
                    showImageUrl: file.url,
                    showImage: true
                })
            },
            // 上传图片成功
            handleImgSuccess(res, file) {

//                if (res.success) {
//
//                } else {
//                    this.error(res.message)
//                }
            },
            // 上传图片前的验证
            beforeImgUpload(file) {

                const isPic = file.type === 'application/x-jpg' || file.type === 'image/jpeg' || file.type === 'application/x-png' || file.type === 'image/png'
//                const isLt20M = file.size / 1024 / 1024 < 20

                if (!isPic) {
                    this.error('上传图片只能是 jpg 或png 格式!')
                }
                else {
                    this.form.photos.push({uid : file.uid, file_id : ''})
                }

                return isPic
            },
            handleRemove(file, fileList) {
                for (var i = 0; i < this.form.photos.length; i++){
                    var obj = this.form.photos[i]
                    if (obj.uid == file.uid){
                        this.form.photos.splice(i,1)
                        return
                    }
                }
            },
        }
    }
</script>

<style lang="scss" module>
    @import '../../../assets/css/default';
</style>



// WEBPACK FOOTER //
// src/pages/serviceWorkOrder/form/firstForm.vue